import {getMethod,download} from './data'
import request from '@/utils/request'
// 文章分类
export function articleCategory(params) {

    return request({
      url: 'api/articleCategory',
      method: 'get',
      params
    })
  }
// /api/article 文章列表
export function article(params) {
  return getMethod('api/article',params)
    // return request({
    //   url: 'api/article',
    //   method: 'get',
    //   params
    // })
  }
// userArticle 用户自己的文章列表
export function userArticle(params) {

  return request({
    url: 'api/userArticle',
    method: 'get',
    params
  })
}
// 文章详情
export function articledetail(params) {

    return request({
      url: 'api/article/'+params,
      method: 'get',
      
    })
  }
  // 对外 文章列表
  export function userArticlemy(params) {

    return request({
      url: 'api/userArticle/my',
      method: 'get',
      params
    })
  }